import { silentLogger } from "@buildwithflux/shared";
/**
 * QUESTION: is this cache ever cleared? what is the memory cost? why not
 * use a WeakMap?
 */
function createDocumentSnapshotCache() {
    return { snapshots: {} };
}
/**
 * Retrieve a snapshot from the cache. A non-existent snapshot stored in the
 * cache should return null.
 *
 * @see storeDocumentSnapshotInCache
 *
 * QUESTION: except for HEAD, why can't we cache by documentVersion alone, which
 * should be a uuid? this would save requests to the same part versions inside
 * different imported parts
 */
function getDocumentSnapshotFromCache(documentUid, documentVersion, cache) {
    const versions = cache.snapshots[documentUid];
    if (versions)
        return versions[documentVersion];
    if (versions === null)
        return null;
    return undefined;
}
/**
 * @see getDocumentSnapshotFromCache
 */
function storeDocumentSnapshotInCache(snapshot, documentUid, documentVersion, cache) {
    if (documentUid in cache.snapshots) {
        const snapshots = cache.snapshots[documentUid];
        if (snapshots)
            snapshots[documentVersion] = snapshot;
    }
    else {
        cache.snapshots[documentUid] = { [documentVersion]: snapshot };
    }
}
/**
 * NOTE: This will cache undefined values!
 */
async function getSnapshotByDescriptor(descriptor, documentSnapshotRepository, cache, logger) {
    const { documentUid, documentVersion } = descriptor;
    const versionToRetrieve = documentVersion;
    // Retrieve from in-memory cache if hit
    const maybeCached = getDocumentSnapshotFromCache(documentUid, versionToRetrieve, cache);
    if (maybeCached || maybeCached === null)
        return maybeCached ?? undefined;
    // Retrieve from cdn if hit
    const maybeCdnHit = await documentSnapshotRepository.get(descriptor);
    storeDocumentSnapshotInCache(maybeCdnHit ?? null, documentUid, documentVersion, cache);
    if (maybeCdnHit) {
        return maybeCdnHit;
    }
    // If no snapshot is found, log it as an error
    logger.debug(`No snapshot found for docUid ${descriptor.documentUid}, version ${descriptor.documentVersion} under schema ${descriptor.schemaTag}`);
    return undefined;
}
export function createSnapshotLibrary(documentSnapshotRepository, logger = silentLogger, documentSnapshotCache = createDocumentSnapshotCache()) {
    return {
        get: (descriptor) => getSnapshotByDescriptor(descriptor, documentSnapshotRepository, documentSnapshotCache, logger),
    };
}
//# sourceMappingURL=library.js.map